import * as THREE from 'three';

const RIM_PAD = 0.2;
const TITLE_PAD = 0.16;
/** Must overlap this much (camera plane) before a title starts shoving a node. */
const TITLE_ENGAGE_SLACK = 0.14;
/** Extra clearance before the node is allowed to slide back home. */
const TITLE_HOLD_PAD = 0.34;
const MAX_NUDGE = 2.8;
const MAX_TOTAL = 4.6;
/** Screen-pixel sizes; world pads shrink when zoomed in so gaps stay similar on screen. */
const RIM_PAD_PX = 8;
const TITLE_PAD_PX = 6;
const TITLE_ENGAGE_PX = 5;
const TITLE_HOLD_PX = 14;
const MAX_NUDGE_PX = 72;
const MAX_TOTAL_PX = 110;

export const CLEAR_PASSES = 4;

let _wpp1 = 0.001;
let _maxNudge = MAX_NUDGE;
let _maxTotal = MAX_TOTAL;
let _padScale = 1;
let _engageScale = 1;

export function setClearTight(tight) {
  _padScale = tight ? 1 : 0.16;
  _engageScale = tight ? 1 : 2.8;
}

/** Screen-space band used to ease a shove in. Wider while idle so grazing stays quiet. */
export function softBand(z) {
  const px = _padScale < 1 ? 32 : 16;
  const cap = _padScale < 1 ? 0.9 : 0.42;
  return Math.min(cap, px * _wpp1 * Math.max(z, 0.4));
}

export function capPush(push) {
  const len = Math.hypot(push.x, push.y);
  if (len <= _maxNudge) return push;
  return { x: (push.x / len) * _maxNudge, y: (push.y / len) * _maxNudge };
}

export function capTotal(gx, gy) {
  const len = Math.hypot(gx, gy);
  if (len <= _maxTotal) return { x: gx, y: gy };
  return { x: (gx / len) * _maxTotal, y: (gy / len) * _maxTotal };
}

export function setScreenPad(camera, container, refZ) {
  const h = Math.max(container?.clientHeight || 1, 1);
  _wpp1 = (2 * Math.tan(THREE.MathUtils.degToRad(camera.fov) * 0.5)) / h;
  const z = Math.max(refZ, 0.8);
  _maxNudge = Math.min(MAX_NUDGE, MAX_NUDGE_PX * _wpp1 * z);
  _maxTotal = Math.min(MAX_TOTAL, MAX_TOTAL_PX * _wpp1 * z);
}

export function padAt(pxAmt, z, cap) {
  return Math.min(cap * _padScale, pxAmt * _padScale * _wpp1 * Math.max(z, 0.4));
}

export function engageSlack(z, mul = 1) {
  return padAt(TITLE_ENGAGE_PX, z, TITLE_ENGAGE_SLACK) * _engageScale * mul;
}

export function rimPad(z) {
  return padAt(RIM_PAD_PX, z, RIM_PAD);
}

export function titlePad(z) {
  return padAt(TITLE_PAD_PX, z, TITLE_PAD);
}

export function titleHoldPad(z) {
  return padAt(TITLE_HOLD_PX, z, TITLE_HOLD_PAD);
}
